
import {PerformanceLogger} from '../performance';
import {ENVIRONMENT_LEVEL} from '@/Constant';
import {CATEGORY, DELAY, LOG_DOC_TYPE} from './const';

const PERFORMANCE_ID = 'x_rlkb_document_paint';
const MEASURE = {
    start: 'editorPaintstart',
    end: 'editorPaintend',
};

export type CategoryType = keyof typeof CATEGORY;

export class EditorPaint {

    key = 'EditorPaint';

    logger: PerformanceLogger;

    category = CATEGORY;

    timeoutHandle: NodeJS.Timeout | null = null;

    time: {[key: string]: any} | null = null;


    constructor(logger: PerformanceLogger) {
        this.logger = logger;
    }

    logWeb =({id, data}: {id: string, data?: any}) => {
        const logger = this.logger;
        const logLevel = logger?.logLevel || '';
        if ([ENVIRONMENT_LEVEL.online, ENVIRONMENT_LEVEL.gray, ENVIRONMENT_LEVEL.qa].includes(logLevel)) {
            this.logger.feLogger({
                id,
                data,
            });
        }
    };

    paintStart = (current: CategoryType, next: CategoryType, docType: string) => {
        // 记录初始时间与初始场景
        this.time = {
            startDate: +new Date(),
            start: performance.now(),
            prev: current,
            next,
        };
        if (performance.clearMarks) {
            performance.clearMarks(MEASURE.start);
            performance.clearMarks(MEASURE.end);
        }
        // performance 记录一次初始mark
        performance.mark && performance.mark(MEASURE.start);
        this.logWeb({
            id: '80001.8.41',
            data: {
                type: `${current}_${next}`,
                docType,
            },
        });
        // 开始计时5s 5s到时 上报一次白屏
        this.timeoutHandle && clearTimeout(this.timeoutHandle);
        this.timeoutHandle = setTimeout(() => {
            // 上报白屏
            this.logWeb({
                id: '80001.8.40',
                data: {
                    type: `${current}_${next}`,
                    docType,
                },
            });
        }, DELAY);
    };

    // 文档渲染速度
    paintEnd = (
        {currentMode, docType, loadedTime}: {currentMode?: CategoryType, docType: string, loadedTime?: number}
    ) => {
        const isSheet = docType === LOG_DOC_TYPE.sheet;
        const isPPT = docType === LOG_DOC_TYPE.ppt;
        const isDataSheet = docType === LOG_DOC_TYPE.datasheet;
        const isDoc = docType === LOG_DOC_TYPE.doc;

        // 清空倒计时
        this.timeoutHandle && clearTimeout(this.timeoutHandle);
        // 根据记录初始时间与初始场景 上报信息
        const timeData = this.time;
        if (!timeData) {
            return;
        }
        // performance 记录一次end mark
        performance.mark && performance.mark(MEASURE.end);
        performance.measure && performance.measure(PERFORMANCE_ID, MEASURE.start, MEASURE.end);
        const startTime = timeData.start;
        const prev = timeData.prev;
        const endTime = performance.now();

        let diff = endTime - startTime;
        // 表格和PPT减去初始化时的时间戳
        if (isSheet || isPPT) {
            diff = loadedTime as number - timeData.startDate;
        }
        // 数据表直接使用 RTE 返回的时间
        if (isDataSheet) {
            diff = loadedTime as number;
        }

        const logData: any = {
            delay: Math.round(diff) || -1,
            docType,
        };
        // 文档需要额外上报type
        if (isDoc) {
            logData.type = `${prev}_${currentMode}`;
        }

        this.logWeb({
            id: '80001.8.38',
            data: logData,
        });
        this.time = null;
    };

    // 用户切换了页面 无法看出是否渲染成功 需要清空之前的记录
    paintStop = () => {
        this.time = null;
        if (performance.clearMarks) {
            performance.clearMarks(MEASURE.start);
            performance.clearMarks(MEASURE.end);
        }
        this.timeoutHandle && clearTimeout(this.timeoutHandle);
    };

    getPaintData = () => {
        const perfs = performance.getEntriesByName(PERFORMANCE_ID);
        return perfs.map(perf => {
            return perf.duration;
        });
    };

    getData() {
        const origin = performance.getEntriesByType(PERFORMANCE_ID);
        const paintData = this.getPaintData();
        return {
            type: this.key,
            paintDelay: paintData,
            origin,
        };
    }
}
